import { render } from "./GalleryFullscreenButton.vue?vue&type=template&id=3861e2f3&scoped=true"
import script from "./GalleryFullscreenButton.vue?vue&type=script&lang=js"
export * from "./GalleryFullscreenButton.vue?vue&type=script&lang=js"

import "./GalleryFullscreenButton.vue?vue&type=style&index=0&id=3861e2f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3861e2f3"]])

export default __exports__